import { render, staticRenderFns } from "./configObjectiveGroup.vue?vue&type=template&id=06bce03a&scoped=true"
import script from "./configObjectiveGroup.vue?vue&type=script&lang=js"
export * from "./configObjectiveGroup.vue?vue&type=script&lang=js"
import style0 from "./configObjectiveGroup.vue?vue&type=style&index=0&id=06bce03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bce03a",
  null
  
)

export default component.exports